import _ from "lodash-es";
import type DataType from "../types/DataType";
import type dataType from "../types/DataType";

export const stringDateNormalizer = (dateTime: string): string => {
  const normalDateTime = dateTime.trim();
  const splitDateTime1 = normalDateTime.split(" ");
  const splitDateTime2 = normalDateTime.split("T");

  const hasTime1 = splitDateTime1.length === 2;
  const hasTime2 = splitDateTime2.length === 2;

  let newDate: string;
  let newTime = "";

  if (hasTime1) {
    newDate = splitDateTime1[0];
    newTime = splitDateTime1[1];
  } else if (hasTime2) {
    newDate = splitDateTime2[0];
    newTime = splitDateTime2[1];
  } else {
    newDate = normalDateTime;
  }

  //normalizeDate
  const splitDate = newDate.split("-");

  if (splitDate.length !== 3) throw new Error("Invalid Date");

  const year = parseInt(splitDate[0]);
  const month = parseInt(splitDate[1]);
  const day = parseInt(splitDate[2]);

  let rv = "";

  const rvDate = `${year}-${month < 10 ? "0" + month : month}-${
    day < 10 ? "0" + day : day
  }`;

  rv += rvDate;

  if (newTime !== "") {
    const splitTime = newTime.split(":");
    if (splitTime.length !== 2) throw new Error("Invalid Time");

    const hours = parseInt(splitTime[0]);
    const minutes = parseInt(splitTime[1]);

    const rvTime = `${hours < 10 ? "0" + hours : hours}:${
      minutes < 10 ? "0" + minutes : minutes
    }`;

    rv += "T" + rvTime;
  }
  return rv;
};
export const dateArrayNormalizer = (data: (string | number)[]): number[] => {
  try {
    if (data.length === 0) return [];
    const rv: number[] = [];
    data.forEach((date) => {
      if (typeof date === "string") {
        const nDate = stringDateNormalizer(date);
        rv.push(new Date(nDate).getTime());
      } else rv.push(date);
    });
    return rv;
  } catch (error) {
    throw new Error("Data not suite for date array normalizer!");
  }
};

export function calculateEMA(prices: number[], periods: number) {
  const ema: number[] = [];
  const k = 2 / (periods + 1);
  ema[0] = prices[0];
  for (let i = 1; i < prices.length; i++) {
    ema[i] = prices[i] * k + ema[i - 1] * (1 - k);
  }
  return ema;
}

export const dataNormalizer = (data: any[]): DataType[] => {
  try {
    if (data.length === 0) return [];
    const rv: DataType[] = [];
    data.forEach((x) => {
      if (
        typeof x?.close !== "number" ||
        (typeof x?.date !== "number" && typeof x?.date !== "string") ||
        typeof x?.high !== "number" ||
        typeof x?.low !== "number" ||
        typeof x?.open !== "number" ||
        typeof x?.volume !== "number"
      ) {
        throw new Error("Data not suite for this chart!");
      }
      if (
        x.position &&
        (!x.position.positionType ||
          !x.position.positionValue ||
          (x.position.sl && typeof x.position.sl !== "number") ||
          (x.position.tp && typeof x.position.tp !== "number") ||
          typeof x.position.positionType !== "string" ||
          (x.position.positionType !== "long" &&
            x.position.positionType !== "short") ||
          typeof x.position.positionValue !== "number")
      ) {
        throw new Error("Data not suite for this chart!");
      }
      rv.push({
        close: x.close,
        date: x.date,
        high: x.high,
        low: x.low,
        open: x.open,
        volume: x.volume,
        position: x?.position
          ? {
              sl: x?.position?.sl,
              tp: x?.position?.tp,
              positionType: x?.position?.positionType,
              positionValue: x?.position?.positionValue,
            }
          : undefined,
      });
    });
    return rv;
  } catch (error) {
    console.error(error);
    throw new Error("Data not suite for this chart!");
  }
};

export const calculateCandleWidthDate = (
  times: number[],
): [candleWidth: number, candleLockerWidth: number] => {
  let indexes = [0, 1];
  let min = times[1] - times[0];
  for (let i = 1; i < times.length; i++) {
    if (times[i + 1] - times[i] < min) {
      min = times[i + 1] - times[i];
      indexes = [i, i + 1];
    }
  }

  const width = times[indexes[1]] - times[indexes[0]];
  return [width - 0.3 * width, width];
};

export const getCursorPoint = (
  id: string,
  evt: MouseEvent,
): { x: number; y: number } => {
  const canvas: HTMLCanvasElement = document.querySelector(
    `#${id}`,
  ) as HTMLCanvasElement;
  const rect: DOMRect = canvas.getBoundingClientRect(),
    root = document.documentElement;

  // return relative mouse position
  const mouseX: number = evt.clientX - rect.left - root.scrollLeft;
  // TODO: for some reason I cannot do that
  // let mouseY: number = evt.clientY - rect.top - root.scrollTop;
  const mouseY: number = evt.clientY - rect.top;
  return {
    x: mouseX,
    y: mouseY,
  };
};

export const getTouchPoint = (
  id: string,
  evt: TouchEvent,
): { x: number; y: number } => {
  const canvas: HTMLCanvasElement = document.querySelector(
    `#${id}`,
  ) as HTMLCanvasElement;
  const rect: DOMRect = canvas.getBoundingClientRect(),
    root = document.documentElement;

  // return relative mouse position
  const mouseX: number = evt.touches[0].clientX - rect.left - root.scrollLeft;
  const mouseY: number = evt.touches[0].clientY - rect.top - root.scrollTop;
  return {
    x: mouseX,
    y: mouseY,
  };
};

// export const findCandleIndex = (inpArray: number[], key: number): number => {
//   let lowIndex = 0;
//   let highIndex = inpArray.length - 1;
//   let midIndex = Math.floor((highIndex + lowIndex) / 2);
//   while (true) {
//     if (key === inpArray[midIndex]) return midIndex;
//
//     if (lowIndex >= highIndex) {
//       return -1;
//     } else if (key > inpArray[midIndex]) {
//       lowIndex = midIndex + 1;
//       midIndex = Math.floor((highIndex + lowIndex) / 2);
//     } else if (key < inpArray[midIndex]) {
//       highIndex = midIndex - 1;
//       midIndex = Math.floor((highIndex + lowIndex) / 2);
//     }
//   }
// };

export const findCandleIndex = (
  inpArray: dataType[],
  candleLockerWidthDate: number,
  keyDate: number,
): number => {
  let lowIndex = 0;
  let highIndex = inpArray.length - 1;
  let midIndex = Math.floor((highIndex + lowIndex) / 2);
  let i = 0;
  while (i++ < 99) {
    if (
      keyDate === inpArray[midIndex]?.date ||
      (keyDate <= inpArray[midIndex]?.date + candleLockerWidthDate / 2 &&
        keyDate >= inpArray[midIndex]?.date - candleLockerWidthDate / 2)
    )
      return midIndex;

    if (lowIndex >= highIndex) {
      return -1;
    } else if (keyDate > inpArray[midIndex]?.date + candleLockerWidthDate / 2) {
      lowIndex = midIndex + 1;
      midIndex = Math.floor((highIndex + lowIndex) / 2);
    } else if (keyDate < inpArray[midIndex]?.date - candleLockerWidthDate / 2) {
      highIndex = midIndex - 1;
      midIndex = Math.floor((highIndex + lowIndex) / 2);
    }
  }
};

interface CreateCandleParams {
  ctx: CanvasRenderingContext2D;
  width: number;
  height: number;
  x: number;
  y: number;
  color: string;
  scale?: number;
}

export function createCandle({
  ctx,
  width,
  height,
  x,
  y,
  color,
  scale = 1,
}: CreateCandleParams): any {
  ctx.setTransform(scale, 0, 0, scale, 0, 0);

  const candle = new Path2D();
  candle.rect(x, y, width, height);
  ctx.fillStyle = color;
  // ctx.strokeStyle = color;
  // ctx.stroke(candle);
  ctx.fill(candle);
  return candle;
}

export const extractChartValues = (data: any, key: string) => {
  const datakeys = (data?.keys || []).filter((d) => d).map((d) => d.key);
  const series = (data?.bars || [])
    .filter((d) => !d.hide)
    .map((d) => ({
      attr: d.key,
      name: d.name,
      color: d.color,
      hide_by_default: d.hide_by_default,
    }));

  const arr = data[key];
  const xs = arr.map((d) => d.datestr);
  const datas = series
    .map((s) => ({
      data: arr.map((d) => d.ret[datakeys.indexOf(s.attr)]),
      name: s.name,
      color: s.color,
      hide_by_default: s.hide_by_default,
    }))
    .filter((d) => {
      return !_.every(d.data, (d) => !d);
    });

  // Sort xs and datas by date ascending before assigning to rawPriceSignal
  const sorted = xs
    .map((date, i) => ({
      date,
      prices: datas.map((dd) => dd.data[i]),
    }))
    .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());
  return { data: sorted, series };
};
